export const getAssetsStyles = () => ({
  '@global': {
    '.text-asset-recommendations-panel .selectable-suggested-item-toggle': {
      height: 'auto',
      minHeight: '32px',

      '& > span': {
        margin: '8px 0',
        textAlign: 'left',
      },
    },
  },
  container: {
    '& .control-label': {
      display: 'none',
    },

    '& .text-assets-collection-container': {
      width: 'auto',
    },

    '& .text-input-container': {
      width: '100%',
    },
    '& .business-name-container': {
      width: 'auto',
    },

    '& .add-asset-btn': {
      marginBottom: '0',
    },
    '& .image-experience-content': {
      minWidth: 'unset !important',
    },
    '& .image-list-choice-group .ms-ChoiceFieldGroup-flexContainer': {
      width: 'unset !important',
    },
    '& .section-description': {
      marginBottom: '16px',
    },
    '& .input-asset-text.error': {
      '& .ms-TextField-fieldGroup, .ms-TextField-fieldGroup::after': {
        borderColor: '#a4262c',
      },
    },
  },
});
